export default __webpack_public_path__ + "static/logo-65c511388b9690eb07c887daaf0bc575.png";